import { AirconSearchProduct, HESLP_AIRCON_SEARCH_PRODUCT } from './aircon-reference-data.model';

/** CER register of solar water heaters: the listing an IPART product was joined to (ESC-130). */
export interface SolarWaterHeaterCerListing {
    brand: string;
    model: string;
    eligibleFrom: string | null;
    eligibleTo: string | null;
}

/**
 * One HESLP-eligible solar (electric boosted) water heater from the QuoteService
 * `reference-data/solar-water-heaters` search (ESC-130): the IPART accepted product joined to its CER register
 * entry, one result per brand/model. As with heat pumps there is no single registry id; `acceptedProductIds`
 * carries every IPART id the brand/model is listed under.
 *
 * NOTE: the QuoteService endpoint (ESC-130) had not shipped when this model was written, so the contract mirrors
 * the heat pump endpoint. Adjust the field names here once the endpoint is live.
 */
export interface SolarWaterHeaterReferenceData {
    brand: string;
    modelNumber: string;
    acceptedProductIds: string[];
    productType: string;
    tankSizeL: number | null;
    effectiveFrom: string | null;
    effectiveTo: string | null;
    cer: SolarWaterHeaterCerListing | null;
    matchTier: string;
}

export interface SolarWaterHeaterSearchResponse {
    results: SolarWaterHeaterReferenceData[];
    totalMatches: number;
}

/** The solar water heater search is HESLP-only: QuoteService rejects any other (or a missing) product. */
export type SolarWaterHeaterSearchProduct = AirconSearchProduct;
export const HESLP_SOLAR_WATER_HEATER_SEARCH_PRODUCT: SolarWaterHeaterSearchProduct = HESLP_AIRCON_SEARCH_PRODUCT;
